module.exports = __webpack_public_path__ + "img/w3_outlet_grey.7799a38f.png";